import React from 'react';
import CollapsibleCurrencyCard from 'components/CollapsibleCurrencyCard';
import { formatMoney, formatNumber } from 'utils/formatting';
import { precisionRound } from 'utils/math';
import CurrencyCard from './CurrencyCard';

export const CmpCurrencyPanel = ({ statusData }) => {
  const cmpPlayerStatus = statusData?.statusV2?.cmpPlayerStatus;
  const freePlay =
    cmpPlayerStatus && precisionRound(cmpPlayerStatus.freePlay, 2) * 100;
  const pointsBalance = cmpPlayerStatus?.basePoints;
  const drawings = cmpPlayerStatus?.drawings;
  const totalDrawingTickets =
    drawings?.reduce((total, drawing) => total + drawing.amount, 0) || 0;

  return (
    <div className="currency-cards">
      <CurrencyCard
        currencyAmount={pointsBalance}
        currencyLabel="Points Balance"
        cardType="points-balance"
        format={formatNumber}
      />
      <CurrencyCard
        currencyAmount={freePlay}
        currencyLabel="Free Play"
        cardType="free-play"
        format={formatMoney}
      />
      <CollapsibleCurrencyCard
        className="casino-drawings-card"
        currencyType="Casino Drawings"
        currencyTotalValue={totalDrawingTickets}
        data={drawings}
      />
    </div>
  );
};

export const PlsCurrencyPanel = ({ statusData }) => {
  const { pointsBalance, freePlay } =
    statusData?.statusV2?.plsPlayerStatus || {};

  return (
    <div className="currency-cards">
      <CurrencyCard
        currencyAmount={pointsBalance}
        currencyLabel="Points Balance"
        cardType="points-balance"
        format={formatNumber}
      />
      <CurrencyCard
        currencyAmount={freePlay}
        currencyLabel="Free Play"
        cardType="free-play"
      />
    </div>
  );
};
